import React, { useState, useEffect } from "react";
import api from "../../api";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";
import ReactSelect from "react-select";
import {
  Paper,
  Grid,
  Button,
  Dialog,
  DialogContent,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import PaymentMethodList from "./PaymentMethodList";
import utils from "../../utils/utils";
import { PaymentMethodTypes } from "../../enums/enums";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  paperFullWidth: {
    overflowY: "visible",
    maxWidth: 300,
  },
  dialogContentRoot: {
    overflowY: "visible",
  },
});

export default function PaymentMethod({ setIsLoading, setDataToast }) {
  let navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [dataTable, setDataTable] = useState();
  const classes = useStyles();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentProcessor, setPaymentProcessor] = useState([]);
  const itemsPerPage = 10;
  const [filterData, setFilterData] = useState({
    paymentMethodType: undefined,
    name: undefined,
  });
  const [paginationData, setPaginationData] = useState({
    count: 0,
    currentPage: 1,
  });
  const [createValues, setCreateValues] = useState({
    id: undefined,
    name: "",
    paymentMethod: "",
    paymentProcessor: "",
    numEntityPayment: "",
    numFormPayment: "",
  });
  const [disabledButtonAcceptNewPaymentMethod, setDisabledButtonAcceptNewPaymentMethod] = useState(true);

  const CustomSelect = ({ Name, Label, Value, Error, ChangeFunction, DataList }) => (
    <FormControl variant="outlined" fullWidth={true} size="small" error={Error ?? ""}>
      <InputLabel>{Label}</InputLabel>
      <Select variant="outlined" value={Value} onChange={ChangeFunction} name={Name} label={Label} error={Error ?? ""}>
        <MenuItem value="">
          <em>Todos</em>
        </MenuItem>
        {DataList &&
          DataList.map((item) => (
            <MenuItem key={item.key} value={item.value}>
              {item.text}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );

  const shortError = (message) => {
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  };

  const handleClickOpen = () => {
    setCreateValues({
      id: undefined,
      name: "",
      paymentMethod: "",
      paymentProcessor: "",
      numEntityPayment: "",
      numFormPayment: "",
    });
    setOpen(true);
  };

  const handleImputChange = (e) => {
    setCreateValues({ ...createValues, name: e.target.value });
  };

  const handleImputChangeNumEntidad = (e) => {
    if (e.target.value > 0) {
      setCreateValues({ ...createValues, numEntityPayment: e.target.value });
    } else {
      setCreateValues({ ...createValues, numEntityPayment: "" });
    }
  };

  const handleImputChangeNumForm = (e) => {
    if (e.target.value > 0) {
      setCreateValues({ ...createValues, numFormPayment: e.target.value });
    } else {
      setCreateValues({ ...createValues, numFormPayment: "" });
    }
  };

  const handleInputChangeTypePaymentMethod = (e) => {
    setCreateValues({ ...createValues, paymentMethod: e });
  };

  function setFilter(e) {
    let name = e.target.name;
    let value = e.target.value;

    setFilterData({ ...filterData, [name]: value });
  }

  function search(e) {
    e.preventDefault();
    reloadData(1, 1, itemsPerPage, true);
  }

  function reloadData(page, from, to, reloadPages) {
    setIsLoading(true);
    let name = filterData.name;
    let paymentMethodType = filterData.paymentMethodType;
    api
      .getPaymentMethodsFilter(1, name, paymentMethodType, from, to, reloadPages)
      .then((res) => {
        let data = res.data;
        let currentPage = page;
        let count = paginationData.count;

        if (reloadPages) {
          if (currentPage !== 1) currentPage = 1;
          count = Math.ceil(data.cantidad / itemsPerPage);
        }

        setPaginationData({
          count: count,
          currentPage: currentPage,
        });
        let list = [];
        data.paymentMethods.forEach((item) => {
          list.push({
            id: item.medioDePagoId,
            name: item.nombreMedioDePago,
            paymentMethodType: item.tipoMedioDePago,
            paymentProcessorName: item.nombreProcesadoraPago,
          });
        });
        setDataTable(list);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error.");
      });
  }

  const checkValueCreatePaymentMethod = () => {
    let response = false;

    if (createValues.paymentMethod.key === 4) {
      return createValues.name.trim() ? (response = true) : (response = false);
    } else if (
      createValues.name.trim() &&
      createValues.paymentMethod &&
      createValues.numEntityPayment &&
      createValues.numFormPayment
    ) {
      response = true;
    }

    return response;
  };

  const onClickCreate = () => {
    if (checkValueCreatePaymentMethod()) {
      var body = {
        nombreMedioDePago: createValues.name.trim(),
        tipoMedioDePago: createValues.paymentMethod.key,
        entidadPagoSapId: parseInt(createValues.numEntityPayment),
        formaPagoSapId: parseInt(createValues.numFormPayment),
      };

      api
        .postPaymentMethod(body)

        .then(() => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: "Medio de pago creado correctamente.",
            type: "success",
          });

          reloadData(1, 1, itemsPerPage, true);
          setOpen(false);
        })

        .catch((err) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: err.response.data.errores ?? "Ocurrió un error.",
            type: "error",
          });
          setOpen(false);
        });
      setCreateValues({
        id: undefined,
        name: "",
        paymentMethod: "",
        paymentProcessor: "",
        numEntityPayment: "",
        numFormPayment: "",
      });
    } else if (!createValues.numFormPayment) {
      shortError("Debe ingresar Número Forma de pago sap");
    } else if (!createValues.paymentMethod) {
      shortError("Debe seleccionar un Medio de Pago");
    } else if (!createValues.numEntityPayment) {
      shortError("Debe ingresar Número de Entidad de pago sap");
    }
    if (!createValues.name.trim()) {
      shortError("Debe ingresar un Nombre");
    }
  };

  useEffect(() => {
    setIsLoading(true);

    Promise.all([api.getListPaymentMethods()])
      .then((res) => {
        setPaymentMethods(utils.setDataInSearchList(res[0].data));
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      <Paper className="c-grid" elevation={3}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid className="c-grid-header" container spacing={1}>
              <Grid item xs={6}>
                <h2>MEDIOS DE PAGO</h2>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  className="c-grid-btn c-btn-success"
                  color="primary"
                  onClick={() => handleClickOpen()}
                >
                  Crear Nuevo
                </Button>

                <Dialog
                  open={open}
                  onClose={() => setOpen(false)}
                  aria-labelledby="form-dialog-title"
                  fullWidth={true}
                  classes={{
                    paperFullWidth: classes.paperFullWidth,
                  }}
                >
                  <DialogTitle id="form-dialog-title">Nuevo Medio de Pago</DialogTitle>
                  <DialogContent>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      label="Nombre medio de pago"
                      type="text"
                      name="nombre"
                      onChange={handleImputChange}
                      fullWidth
                      required
                    />
                  </DialogContent>
                  <DialogContent>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      label="Número entidad de pago sap"
                      type="number"
                      name="numEntidad"
                      onChange={handleImputChangeNumEntidad}
                      fullWidth
                      inputProps={{ min: 0 }}
                      value={createValues.numEntityPayment || ""}
                      required={createValues.paymentMethod.key !== PaymentMethodTypes.Cash.Id}
                    />
                  </DialogContent>
                  <DialogContent>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      label="Número forma de pago sap"
                      type="number"
                      name="numFormulario"
                      onChange={handleImputChangeNumForm}
                      fullWidth
                      inputProps={{ min: 0 }}
                      value={createValues.numFormPayment || ""}
                      required={createValues.paymentMethod.key !== PaymentMethodTypes.Cash.Id}
                    />
                  </DialogContent>
                  <DialogContent
                    classes={{
                      root: classes.dialogContentRoot,
                    }}
                    style={{ maxWidth: 300, marginTop: 15 }}
                  >
                    <ReactSelect
                      styles={{ maxWidth: 350 }}
                      placeholder="Tipo medio de Pago..."
                      options={paymentMethods}
                      onChange={handleInputChangeTypePaymentMethod}
                      value={createValues.paymentMethod}
                      required
                    />
                  </DialogContent>

                  <DialogActions>
                    <Button onClick={() => setOpen(false)} className="c-btn-cancel">
                      Cancelar
                    </Button>
                    <Button type="submit" onClick={() => onClickCreate()} className="c-btn-success">
                      Aceptar
                    </Button>
                  </DialogActions>
                </Dialog>
              </Grid>

              <Grid item xs={12}>
                <form onSubmit={search}>
                  <Grid container spacing={1}>
                    <Grid item md={3} xs={12}>
                      <TextField
                        fullWidth={true}
                        variant="outlined"
                        onChange={setFilter}
                        size="small"
                        name="name"
                        label="Nombre"
                      />
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <FormControl variant="outlined" fullWidth={true} size="small">
                        <ReactSelect
                          placeholder="Tipo medio de pago..."
                          name="paymentMethodType"
                          onChange={(e) => {
                            setFilterData({
                              ...filterData,
                              paymentMethodType: e ? e.value : undefined,
                            });
                          }}
                          options={paymentMethods}
                          isClearable={true}
                          required
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <Button
                        className="c-btn-info c-mt-2"
                        variant="contained"
                        fullWidth={true}
                        type="submit"
                        startIcon={<SearchIcon />}
                        onClick={() => navigate("/medios-pago")}
                      >
                        Buscar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <PaymentMethodList
        setIsLoading={setIsLoading}
        setDataToast={setDataToast}
        dataTable={dataTable}
        classes={classes}
        paymentMethods={paymentMethods}
        paymentProcessorr={paymentProcessor}
        setDataTable={setDataTable}
        shortError={shortError}
        reloadData={(page, from, to, reloadPage) => reloadData(page, from, to, reloadPage)}
        paginationData={paginationData}
      />
    </>
  );
}
